// extracted by mini-css-extract-plugin
export var body = "_cn-0";
export var sectionHeader = "_cn-4";
export var shortcutColumns = "_cn-2";
export var shortcutList = "_cn-1";
export var shortcutSection = "_cn-3";